import { render, staticRenderFns } from "./CheckboxChangeIcon.vue?vue&type=template&id=368b7458"
import script from "./CheckboxChangeIcon.vue?vue&type=script&lang=js"
export * from "./CheckboxChangeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports